<template>
 <div class="row mt-4 mb-2 font-weight-bold" style="font-size: 16px; text-decoration: underline;"> {{ $t('demand.tabs.summary.client.label') }}</div>
    <div class="row">
        <div class="col-6">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.client.name') }}
          </label>
          <span class="font-weight margin-left color" >
           {{clientName}}
          </span>
        </div>
        <div class="col-6">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.client.phone') }}
          </label>
          <span class="font-weight margin-left color" >
            {{clientPhone}}
          </span>
        </div>
    </div>   
     <div class="row">
        <div class="col-6">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.client.mail') }}
          </label>
          <span class="font-weight margin-left color text-primary " 
          :style="clientMail !='-' ? 'text-decoration: underline;' : null">
            {{clientMail}}
          </span>
        </div>
        <div class="col-6">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
             {{ $t('demand.tabs.summary.client.deliveryAdress') }}
           
          </label>
          <span class="font-weight margin-left color" >
            {{deliveryAdress}}
          </span>
        </div>
    </div>       
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";


@Options({
    props: ["orderClient","asset"],
  components: {
  },
})
export default class summaryTabOrderClient extends Vue {
   orderClient?: any;
   asset?: any;

   get client (){
      return this.orderClient  && this.orderClient.orderParty && this.orderClient.orderParty.party && this.orderClient.orderParty.party.rawData && this.orderClient.orderParty.party.rawData.responseData
                   ? this.orderClient.orderParty.party.rawData.responseData
                   : null
   }
   get clientName() {
    const  clientType  = this.orderClient  && this.orderClient.orderParty && this.orderClient.orderParty.party && this.orderClient.orderParty.party.objectType
                   ? this.orderClient.orderParty.party.objectType
                   : "-"
    return clientType === "odm.party.party.person.frenchperson" 
            ? `${this.client.firstName} ${this.client.familyName}`
            : clientType === "odm.party.party.organization.frenchorganization"
            ?  `${this.client.name}`
            : "-"
  }

  get clientPhone() {
      const contact = this.client && this.client.contacts 
              ? this.client.contacts?.find((contact:any) => contact?.contactMechanism?.type?.id === 'PHONE_CONTACT')
              : null
      return contact && contact.contactMechanism &&  contact.contactMechanism.phoneNumber ? contact.contactMechanism.phoneNumber : "-"
  }
  get clientMail() {
    const contact = this.client && this.client.contacts 
              ? this.client.contacts?.find((contact:any) => contact?.contactMechanism?.type?.id === 'EMAIL_CONTACT') 
              : null;
    return contact && contact.contactMechanism &&  contact.contactMechanism.emailAddress ? contact.contactMechanism.emailAddress : "-"
  }
  get deliveryAdress(){
    return this.asset && this.asset.assetDelivery && this.asset.assetDelivery.description 
            ? this.asset.assetDelivery.description 
            : "-"
  }
}
</script>

<style scoped>
</style>
